import { useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleButton from "../buttons/SimpleButton";
import styles from "./styles.module.css";
import { NewRobotIdE, useConnectedRafts } from "../../../store/SelectedRaftContext";

export default function UpdateRaftName() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { connectedRafts } = useConnectedRafts();
  const selectedRaft = connectedRafts.find(connectedRaft => connectedRaft.isSelected && connectedRaft.id !== NewRobotIdE.NEW);
  const [raftName, setRaftName] = useState(selectedRaft?.name || "");

  const onChangeName = async () => {
    if (!selectedRaft) return;
    setIsLoading(true);
    await window.applicationManager.updateRaftNameInAllStates(selectedRaft.id, raftName);
    setIsLoading(false);
  };

  return (
    <div className={styles.updateRaftNameContainer}>
      <p className={styles.updateRaftNameTitle}>
        {isLoading
          ? t("update_raft_name.updating")
          : t("update_raft_name.current_name", { name: selectedRaft?.name }) || `Current Name: ${selectedRaft?.name}`
        }
      </p>
      <input
        type="text"
        className={styles.updateRaftNameInputField}
        value={raftName}
        onChange={(e) => setRaftName(e.target.value)}
      />
      <div className={styles.updateRaftButtonContainer}>
        <SimpleButton onClick={onChangeName} title={t("update_raft_name.update")} disabled={isLoading} />
      </div>
    </div>
  );
}
